<template>
  <div style="position: relative;">
    <el-row>
      <el-col :span="24">
        <el-table ref="specialistMember" :data="specialistMemberList.SpecialistMember.impl.dataList" :size="defaultFormItemSize" @sort-change="specialistMemberList.SpecialistMember.impl.onSortChange"
          header-cell-class-name="table-header-gray"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="specialistMemberList.SpecialistMember.impl.getTableIndex" />
          <el-table-column label="专家名称" prop="specialistName">
          </el-table-column>
          <el-table-column label="专家照片" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                :preview-src-list="getPictureList(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" prop="mobilePhone">
          </el-table-column>
          <el-table-column label="专业领域" prop="industryName">
          </el-table-column>
          <el-table-column label="职称" prop="specialistTitle">
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialistMemberList.SpecialistMember.impl.totalCount"
            :current-page="specialistMemberList.SpecialistMember.impl.currentPage"
            :page-size="specialistMemberList.SpecialistMember.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialistMemberList.SpecialistMember.impl.onCurrentPageChange"
            @size-change="specialistMemberList.SpecialistMember.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SpecialistMemberController, DictionaryController } from '@/api';

export default {
  name: 'specialistMemberList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      specialistMemberList: {
        formFilter: {
        },
        formFilterCopy: {
        },
        SpecialistMember: {
          impl: new TableWidget(this.loadSpecialistMemberWidgetData, this.loadSpecialistMemberVerify, true, false)
        },
        isInit: false
      }
    }
  },
  methods: {
    /**
     * 专家组成员表数据获取函数，返回Promise
     */
    loadSpecialistMemberWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params
      }
      return new Promise((resolve, reject) => {
        SpecialistMemberController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专家组成员表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSpecialistMemberVerify () {
      return true;
    },
    /**
     * 更新团队成员列表
     */
    refreshSpecialistMemberList (reloadData = false) {
      if (reloadData) {
        this.specialistMemberList.SpecialistMember.impl.refreshTable(true, 1);
      } else {
        this.specialistMemberList.SpecialistMember.impl.refreshTable();
      }
      if (!this.specialistMemberList.isInit) {
        // 初始化下拉数据
      }
      this.specialistMemberList.isInit = true;
    },
    onResume () {
      this.refreshSpecialistMemberList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshSpecialistMemberList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
